<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">任务下发</div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content">
        <el-form-item label="关联消息" v-if="isRelateMsg">
          <div class="textover" :style="inlineItemStyle80">
            {{ delLabel(messageDatail.messageTypeName) }}：{{ delLabel(messageDatail.content) }}<span></span>
          </div>
        </el-form-item>
        <el-form-item label="任务名称" prop="TaskTiltle">
          <el-input
            :style="inlineItemStyle80"
            v-model="ruleform.TaskTiltle"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务内容" prop="TaskDesc">
          <el-input
            :style="inlineItemStyle80"
            type="textarea"
            rows="2"
            v-model="ruleform.TaskDesc"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务坐标">
          <el-input
            :style="inlineItemStyle25"
            v-model="ruleform.Longitude"
          ></el-input>
          <el-input
            :style="inlineItemStyle25"
            v-model="ruleform.Latitude"
          ></el-input>
          <ZjLngLatSelect
            class="newtaskposition"
            :point_lat="ruleform.Latitude"
            :point_lng="ruleform.Longitude"
            @onGotLngLat="onGotLngLat"
          ></ZjLngLatSelect>
        </el-form-item>
        <el-form-item label="任务地址" prop="Location">
          <el-input
            :style="inlineItemStyle50"
            v-model="ruleform.Location"
          ></el-input>
        </el-form-item>
        <el-form-item label="计划响应时间" prop="PlanResponseTime">
          <el-input-number
            :min="0"
            v-model="ruleform.PlanResponseTime"
            controls-position="right"
          ></el-input-number>
          <label>分钟</label>
        </el-form-item>

        <el-form-item label="负责人" prop="ChargerName">
          <el-input
            :style="inlineItemStyle50"
            v-model="ruleform.ChargerName"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="PhoneList">
          <div>任务会通过短信的形式发送给相关人员</div>
          <div
            :style="{ margin: '2px 0px' }"
            v-for="(item, index) in ruleform.PhoneList"
            :key="index"
          >
            <el-input
              :style="inlineItemStyle50"
              v-model="item.Phone"
            ></el-input>
            <el-button
              :style="{ 'background-color': 'transparent' }"
              @click="addContact()"
              >添加</el-button
            >
            <el-button
              :style="{
                color: '#f04a4c',
                'background-color': 'transparent',
                'border-color': '#f04a4c',
              }"
              @click="removeContact(index)"
              >删除</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="从通信录选择">
          <UserTree v-if="isshow" />
          <!-- <UserTabControl v-if="isshow" ref="userTabls" /> -->
        </el-form-item>
      </zj-layout-container>
      <zj-layout-container class="footer">
        <el-form-item class="btns">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="submitForm('ruleform')"
            >提交</el-button
          >
        </el-form-item>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import ZJApp from "../../../../../app";
import Constant from "../config/constant";
import UserTree from "./UserTree";
import UserTabControl from "../../../../../emergency/src/views/src/Plan/UserTabControl";
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../apis";
import { mapGetters, mapActions } from "vuex";
import { bus } from "../../../apis/bus.js";
import { queryDevice } from "../../../../../../request/msgApi";
export default {
  name: "ZJEmergencyComponentNewTaskHome",
  componentName: "ZJEmergencyComponentNewTaskHome",
  components: {
    UserTree,
    UserTabControl,
  },
  props: {
    // ExecutId: {
    //   type: String,
    //   default: ""
    // },
    isLookDetails: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Object,
      default: function () {
        return [];
      },
    },
    messageDatail: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["getEarlymsg", "getMsgTask"]),
  },
  watch: {
    getEarlymsg: function (val) {
      console.log(val);
    },
    isLookDetails: function (val) {
      console.log("isLookDetails");
      console.log(val);
      if (val) {
        this.getTaskDetails();
      }
    },
    messageDatail(val) {
      if (val && val.id) {
        this.isRelateMsg = true;
      } else {
        this.isRelateMsg = false;
      }
    },
  },
  data() {
    return {
      inlineItemStyle25: {
        width: "25%",
        "margin-right": "2rem",
      },
      inlineItemStyle50: {
        width: "50%",
        "margin-right": "2rem",
      },
      inlineItemStyle80: {
        width: "80%",
        "margin-right": "2rem",
      },
      isshow: true,
      isRelateMsg: false, //是否从消息那带过来的
      positions: [
        { label: "之后插入", value: "1" },
        { label: "之前插入", value: "2" },
      ],
      ruleform: {
        Creater: ZJApp.ZJUser.current.UserName,
        CreateTime: new Date(),
        Modifier: ZJApp.ZJUser.current.UserName,
        ModifyTime: new Date(),
        Validity: 1,
        Extend1: "人工下发",
        OrgId: this.getOrgId(),
        ExecutTaskId: ZJApp.ZJUtils.uuid(),
        ExecutId: "newtaskfortaskcenter",
        TaskTiltle: "",
        TaskDesc: "",
        ChargerId: "",
        ChargerName: "",
        Phone: "",
        PlanResponseTime: 0,
        ExecWay: "2", // 1:auto，2：manual
        PlanResourceId: "",
        OrderNo: 0,
        Memo: "",
        TaskStatus: Constant.TaskStatus.Todo.code,
        Location: "",
        Longitude: 0,
        Latitude: 0,
        ListReceiver: [],
        PhoneList: [{ Phone: "" }],
      },
      rules: {
        TaskTiltle: [
          { required: true, message: "请选择任务名称", trigger: "blur" },
        ],
        TaskDesc: [
          { required: true, message: "请填写任务描述", trigger: "blur" },
          {
            min: 0,
            max: 1000,
            message: "长度最长为1000个字符",
            trigger: "blur",
          },
        ],
        PhoneList: [
          {
            type: "array",
            required: false,
            validator: this.validphone,
            trigger: "blur",
          },
        ],
      },
      msgkey: "",
      currenttaskvalue: "",
      positionvalue: "",
      startTaskMsgKey: "MessageKey_TaskCenterStartTask",
      userTreeIds: {},
      AlertTypeArr: [],
    };
  },
  created() {
    // if(this.isLookDetails){
    //   this.getTaskDetails();
    // }

    bus.$on("getIds", ({ code, ids }) => {
      this.userTreeIds[code] = ids;
    });
  },
  mounted() {
    this.getAlarmType();
  },
  methods: {
    delLabel(str) {
      const reg = /(<([^>]+)>)/ig
      return str.replace(reg, "")
    },
    //如果是消息转任务，自动填充部分字段
    initInfo() {
      if (
        (this.messageDatail.messageType == "early_warning" ||
          this.messageDatail.messageType == "help") &&
        this.messageDatail.extra
      ) {
        const alarmInfo = JSON.parse(this.messageDatail.extra);
        this.messageDatail.levelName =
          this.getLevel(alarmInfo.AlerteLevel) || this.messageDatail.levelName;

        this.messageDatail.categoryName =
          this.getType(alarmInfo.AlertType) || this.messageDatail.categoryName;
        if (alarmInfo.AlertType == 20 || alarmInfo.AlertType == 23) {
          let content = alarmInfo.Content;
          content = content.substring(
            content.indexOf("【") + 1,
            content.indexOf("】")
          );
          if (content) {
            this.findEquip(content);
          }
        }
      }
      this.ruleform.TaskTiltle =
        "处理" + this.messageDatail.messageTypeName || "";
      //【时间】【级别加事件类型】【位置】【描述】+请处理
      this.ruleform.TaskDesc =
        this.messageDatail.dataTime +
        "，" +
        (this.messageDatail.levelName || "") +
        (this.messageDatail.categoryName ||
          this.messageDatail.messageTypeName) +
        "，" +
        (this.messageDatail.address || "") +
        (this.messageDatail.content.replace(/(<([^>]+)>)/ig, "") || "") +
        "，请处理";
      this.ruleform.Longitude = this.messageDatail.longitude;
      this.ruleform.Latitude = this.messageDatail.latitude;
      if (this.ruleform.Longitude && this.ruleform.Latitude) {
        this.getAddress(this.ruleform.Longitude, this.ruleform.Latitude);
      }
    },
    //如果是环境监测的设备，按照名称获取经纬度
    findEquip(deviceName) {
      let params = {
        id: this.msgId,
        page: 1,
        size: 10,
        typeOneCode: "environmental_monitor",
        name: deviceName,
        model: "dustNoiseDevice",
      };
      const that = this;
      that.center = [];
      queryDevice(params).then((res) => {
        if (res && res.data.length > 0) {
          if (res.data[0].longitude && res.data[0].latitude) {
            this.ruleform.Longitude = res.data[0].longitude;
            this.ruleform.Latitude = res.data[0].latitude;
            this.getAddress(this.ruleform.Longitude, this.ruleform.Latitude);
          }
        }
      });
    },
    getLevel: function (value) {
      let result = "";

      switch (value) {
        case 3:
          result = "蓝色";
          break;
        case 5:
          result = "黄色";
          break;
        case 7:
          result = "橙色";
          break;
        case 10:
          result = "红色";
          break;
      }
      return result;
    },
    getType: function (value) {
      let AlertTypeArr = this.AlertTypeArr;
      let result = "";
      AlertTypeArr.forEach((item) => {
        if (value == item.Extend1) {
          result = item.Description;
        }
      });
      return result;
    },
    getAlarmType() {
      //预警类型
      this.config
        .getUValue("AlarmSubsystem:AlarmType", "")
        .then((d) => {
          this.AlertTypeArr = d.JValue;
          if (this.messageDatail && this.messageDatail.id) {
            this.isRelateMsg = true;
            this.initInfo();
          } else {
            this.isRelateMsg = false;
          }
        })
        .catch((e) => console.error(e));
    },
    //根据经纬度反解析地址
    getAddress(Longitude, Latitude) {
      const that = this;
      // 创建地理编码实例, 并配置参数获取乡镇级数据
      var myGeo = new BMap.Geocoder({ extensions_town: true });
      // 根据坐标得到地址描述
      myGeo.getLocation(new BMap.Point(Longitude, Latitude), function (result) {
        if (result) {
          that.ruleform.Location = result.address || "";
        }
      });
    },
    validphone: function (rule, value, callback) {
      console.log("validphone");
      if (!value || value.length == 0) {
        callback();
        // callback(new Error("请输入电话号码"));
      } else if (!this.validphonelist(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    validphonelist(arr) {
      var result = arr.every(function (item) {
        if (item.Phone == "") {
          return true;
        } else {
          return ZJApp.ZJUtils.isRightMobileNum(item.Phone);
        }
      });
      return result;
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate().then((valid) => {
        if (valid) {
          //插入反馈数据
          var newtask = that.getNewTask();
          if (newtask.ListReceiver.length == 0) {
            this.$message({
              message: "联系电话不能为空！",
              type: "error",
            });
            return;
          }
          if (that.isRelateMsg) {
            newtask["Extend2"] = that.messageDatail.id;
          }
          console.log("newtask");
          console.log(newtask);
          new MyApis.ExecutTaskApi()
            .StartTaskManual(newtask)
            .then((r) => {
              that.$emit("newtaskcreated");
              if (that.messageDatail?.id) {
                that.$emit("closeTask", {});
              }

              let data = r.data.Data;
              if (data) {
                var msgcontent = {
                  key: this.startTaskMsgKey,
                  data: newtask.ExecutTaskId,
                };
                this.$notify.broadcase(msgcontent);
                that.$message({
                  message: r.RspMsg ? r.RspMsg : "下发任务成功！",
                  type: "success",
                });
                //关闭当前弹窗
                that.$emit("handlerclose");
              } else {
                that.$message({
                  message: r.RspMsg ? r.RspMsg : "下发任务失败！",
                  type: "error",
                });
              }
            })
            .catch((e) => {
              console.error(e);
              that.$message({
                message: e.RspMsg ? e.RspMsg : "下发任务失败！",
                type: "error",
              });
            });
        }
      });
    },
    addContact() {
      this.ruleform.PhoneList.push({ Phone: "" });
    },
    removeContact(index) {
      if (this.ruleform.PhoneList.length > 1) {
        this.ruleform.PhoneList.splice(index, 1);
      }
    },
    onBack: function () {
      this.$emit("handlerclose");
    },
    getOrgId: function () {
      let deptId =
        ZJApp.ZJUser.current.Departments.length > 0
          ? ZJApp.ZJUser.current.Departments[0].OrgId
          : "error-no-department";
      return deptId;
    },
    onGotLngLat(obj) {
      this.ruleform.Latitude = obj.lat || 0;
      this.ruleform.Longitude = obj.lng || 0;
      this.getAddress(this.ruleform.Longitude, this.ruleform.Latitude);
    },
    getUserIds() {
      let userids = [];
      var chil = this.$refs["userTabls"];
      if (chil && chil.GetOrgUserIds) {
        userids = chil.GetOrgUserIds();
      }
      return userids;
    },
    getNewTask() {
      var task = this.ruleform;

      // var userids = this.getUserIds();
      var userids = [];
      Object.keys(this.userTreeIds).map((item) => {
        userids = userids.concat(this.userTreeIds[item]);
      });
      console.log(userids, "0000");
      // if(userids.length == 0 && this.ruleform.PhoneList.length == 0){
      //   that.$message({
      //     message:'联系电话不能为空！',
      //     type: "error"
      //   });
      //   return
      // }
      if (userids) {
        for (let i = 0; i < userids.length; i++) {
          if (userids[i]) {
            task.ListReceiver.push({
              Creater: ZJApp.ZJUser.current.UserName,
              //CreateTime :  new Date(),
              Modifier: ZJApp.ZJUser.current.UserName,
              //ModifyTime :  new Date(),
              Validity: 1,
              //Extend1: userids[i],
              OrgId: this.getOrgId(),
              ExecutId: this.ExecutId,
              ExecutReceiverId: ZJApp.ZJUtils.uuid(),
              ReceiverId: userids[i],
            });
          }
        }
      }

      for (let i = 0; i < this.ruleform.PhoneList.length; i++) {
        if (this.ruleform.PhoneList[i].Phone) {
          task.ListReceiver.push({
            Creater: ZJApp.ZJUser.current.UserName,
            //CreateTime :  new Date(),
            Modifier: ZJApp.ZJUser.current.UserName,
            //ModifyTime :  new Date(),
            Validity: 1,
            Extend1: this.ruleform.PhoneList[i].Phone,
            OrgId: this.getOrgId(),
            ExecutId: this.ExecutId,
            ExecutReceiverId: ZJApp.ZJUtils.uuid(),
          });
        }
      }

      return task;
    },
    currentTaskSelectChange(value) {
      console.log(value);
    },
    currentPositionSelectChange(value) {
      console.log(value);
    },
  },
  beforeDestroy() {
    // 注销监听事件
    bus.$off(["getIds"]);
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .content > .el-form-item > .el-form-item__label {
    flex: 0 0 auto !important;
  }
}
.textover {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
}
</style>